import { PlusOutlined } from '@ant-design/icons';
import { Button, Card } from 'antd';
import React, { useContext, useState } from 'react';
import { AppContext } from '../../../../../AppContext';
import {
  MODULES,
  PERMISSIONS_KEY,
  PERMISSION_TYPE,
} from '../../../../../common/constants';
import { hasPermission } from '../../../../../common/utils';
import Portal from '../../../../../components/Portal';
import ContentMasterTable from '../components/ContentMasterTable';

const ContentMasters = () => {
  const {
    state: { permissions },
  } = useContext(AppContext);
  const [isContentMasterModalOpen, setIsContentMasterModalOpen] = useState(
    false,
  );
  const [contentMasterImages, setContentMasterImages] = useState([]);

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.CONTENT_MASTER}</div>
      </Portal>
      <Portal portalId="header-right-content">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_CONTENT,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsContentMasterModalOpen(true);
              setContentMasterImages([]);
            }}
          >
            Add New Content Master
          </Button>
        )}
      </Portal>
      <Portal portalId="header-right-content-phones">
        {hasPermission(
          PERMISSIONS_KEY?.MASTER_LIST_CONTENT,
          PERMISSION_TYPE?.CREATE,
          permissions,
        ) && (
          <Button
            className="common-button"
            size="middle"
            icon={<PlusOutlined />}
            onClick={() => {
              setIsContentMasterModalOpen(true);
              setContentMasterImages([]);
            }}
          >
            Add New Content Master
          </Button>
        )}
      </Portal>
      <Card className="full-height-without-nav">
        <ContentMasterTable
          isContentMasterModalOpen={isContentMasterModalOpen}
          setIsContentMasterModalOpen={setIsContentMasterModalOpen}
          contentMasterImages={contentMasterImages}
          setContentMasterImages={setContentMasterImages}
        />
      </Card>
    </>
  );
};

export default ContentMasters;
